import { all, fork } from 'redux-saga/effects';
import common from 'shared/sagas';
import auth from './auth';
import orderSubmitFlow from './orderSubmitFlow';
import ideaLandingSaga from 'components/IdeaLanding/sagas';
import orderSubmitModal from 'components/OrderSubmitModal/sagas';
import { trackedStockSubmitBuyOrder } from 'modules/StockSubmitSection/saga';
import deposit from './deposit';
import withdraw from './withdraw';
import conversion from './conversion';
import { routeChange } from './routeChange';
import ab from './ab';
import { tabs } from './tabs';

export default function* rootSaga() {
  tabs();
  yield all([
    fork(routeChange),
    fork(common),
    fork(auth),
    fork(orderSubmitFlow),
    fork(ideaLandingSaga),
    fork(trackedStockSubmitBuyOrder),
    fork(orderSubmitModal),
    fork(deposit),
    fork(withdraw),
    fork(conversion),
    fork(ab),
  ]);
}
